/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { AgencySettingsViewModel } from './AgencySettingsViewModel'; 

export function getAgencySettingsOptions(onSuccess?: (result: AgencySettingsViewModel) => void) {
	return queryOptions({
		queryKey: ['agency-settings'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/agenciessettings/queries/getagencysettings/';
			const resp = await axios.get<AgencySettingsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}